import { PageContainer } from "../components/PageContainer";

import { CertificateForm } from "../components/CertificateForm";

export const GiveCertificate = () => {
  return (
    <PageContainer>
      <CertificateForm />
    </PageContainer>
  );
};
